export enum AnalyticsDashBoardType {
  UNSET = 'unset',
  LEARNING_JOURNEY = 'learning_journey',
  INSTITUTION = 'institution',
  COURSE = 'course',
}
